
import { defineComponent, PropType } from 'vue'
import { RepositoryComplianceReportItem, RepositoryKindChoices } from '~/types/types'
import { resolveNodes } from '~/utils/array'

export default defineComponent({
  name: 'ReportRepositoriesPage',
  props: {
    repositoryList: {
      type: Array as PropType<RepositoryComplianceReportItem[]>,
      required: true
    },
    searchTerm: {
      type: String,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    totalPageCount: {
      type: Number,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    tag: {
      type: String,
      required: true
    },
    owner: {
      type: String,
      required: true
    },
    provider: {
      type: String,
      required: true
    },
    customCardInfoWidths: {
      type: String,
      default: 'md:w-[90%] md:w-[10%]'
    }
  },
  emits: {
    'update:searchTerm': (searchTerm: string) => true,
    'update:currentPage': (currentPage: number) => true
  },
  computed: {
    perPageCount(): number {
      return 5
    },
    emptyStateBindings() {
      if (this.searchTerm) {
        return {
          title: `No results found for '${this.searchTerm}'`,
          'webp-image-path': require('~/assets/images/ui-states/directory/empty-search.webp'),
          'png-image-path': require('~/assets/images/ui-states/directory/empty-search.gif'),
          subtitle: 'Please try changing your search query.',
          'show-border': true
        }
      }

      return {
        title: 'No repositories',
        subtitle: `There are no repositories with ${this.tag} issues.`,
        'show-border': true
      }
    }
  },
  methods: {
    getRepoRoute(repoName: string): string {
      return this.$router.resolve({
        name: 'provider-owner-repo-issues',
        params: {
          provider: this.provider,
          owner: this.owner,
          repo: repoName
        },
        query: { q: `tag:${this.tag}`, category: 'all' }
      }).href
    },
    getRepotitle(repoName: string): string {
      return `${this.owner} / ${repoName}`
    },
    getRepoIcon({ kind, isPrivate }: RepositoryComplianceReportItem): string {
      if (kind === RepositoryKindChoices.Subrepo) {
        return isPrivate ? 'folder-locked' : 'folder-globe'
      }

      if (kind === RepositoryKindChoices.Repo) {
        return isPrivate ? 'z-lock' : 'globe'
      }

      return 'monorepo'
    },
    getAnalyzers(analyzersConnection: RepositoryComplianceReportItem['availableAnalyzers']) {
      return resolveNodes(analyzersConnection)
    }
  }
})
